import React, { useRef } from 'react';
import IssueCreateForm from './components/issueCreateForm';
import BaseComponent from './components/BaseComponent';
import { viewTypes } from './constants/view-types';
import { FORM_CONFIG_NAMES } from './constants/issue-attribute-names';

const CreateRfiFormForEntityLinker = React.forwardRef((props, forwardRef) => {
  const containerRef = useRef(null);

  const handleIframeOpenClose = (state) => () => {
    const entityPickerModal = document.querySelector('.EntityPickerModal.SimpleModal-dialog');

    if (entityPickerModal) {
      entityPickerModal.style.transform = state === 'open' ? 'none' : 'translate(0,0)';
    }
  };

  return (
    <BaseComponent
      disableNotifications
      onIframeOpen={handleIframeOpenClose('open')}
      onIframeClose={handleIframeOpenClose('close')}
    >
      <IssueCreateForm
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        container={containerRef.current}
        ref={forwardRef}
        formConfig={FORM_CONFIG_NAMES.ENTITY_LINKER}
        viewType={viewTypes.PROJECT}
      />
    </BaseComponent>
  );
});
CreateRfiFormForEntityLinker.displayName = 'CreateRfiFormForEntityLinker';

export default CreateRfiFormForEntityLinker;
